import {Injectable} from '@angular/core';
import {QuestionBase} from '../components/general/question/question-base';
import {TextboxQuestion} from '../components/general/question/question-textbox';
import {GroupService} from './group.service';
import {UserRightService} from './user-right.service';
import {DateQuestion} from '../components/general/question/question-date';
import {DropdownQuestion} from '../components/general/question/question-dropdown';
import {UserRight} from '../interfaces/userRight';
import {UserRightGroupService} from './user-group-right.service';
import {ServiceTools} from './serviceTools';
import { MessageService } from '../../shared/message.service';
import { SuperuserServiceModule } from '../superuser-service.module';


// import {AppMetadata, Identity, UserMetadata} from '../interfaces/user';

@Injectable({
  providedIn: SuperuserServiceModule
})
export class QuestionService {

  constructor(private groupService: GroupService,
              private userRightService: UserRightService,
              private userGroupRightService: UserRightGroupService,
              private messageService: MessageService,
  ) {

  }

  async getQuestions(name: string): Promise<QuestionBase<any>[]> {
    if (name === 'group') {
      const questions: QuestionBase<any>[] = [
        new TextboxQuestion({
          key: 'id',
          label: 'Id',
          required: true,
          order: 1
        }),
        new TextboxQuestion({
          key: 'name',
          label: 'Name',
          required: true,
          order: 2
        }),
        new DateQuestion({
          key: 'createdAt',
          label: 'Created at',
          readOnly: true,
          required: false,
          order: 3
        }),
        new DateQuestion({
          key: 'updatedAt',
          label: 'Updated at',
          readOnly: true,
          required: false,
          order: 4
        }),
        new TextboxQuestion({
          key: 'deletedAt',
          label: 'Deleted at',
          readOnly: true,
          required: false,
          order: 5
        })
      ];
      return questions.sort((a, b) => a.order - b.order);
    }

    if (name === 'tenant') {
      const questions: QuestionBase<any>[] = [
        new TextboxQuestion({
          key: 'id',
          label: 'Id',
          required: true,
          order: 1
        }),
        new TextboxQuestion({
          key: 'name',
          label: 'Name',
          required: true,
          order: 2
        }),
        new TextboxQuestion({
          key: 'database',
          label: 'Database',
          required: true,
          order: 3
        }),
        new TextboxQuestion({
          key: 'folderName',
          label: 'Folder name',
          required: true,
          order: 4
        }),
        new TextboxQuestion({
          key: 'miproTenantName',
          label: 'Mipro tenant name',
          required: true,
          order: 5
        }),
        new DateQuestion({
          key: 'createdAt',
          label: 'Created at',
          readOnly: true,
          required: false,
          order: 6
        }),
        new DateQuestion({
          key: 'updatedAt',
          label: 'Updated at',
          readOnly: true,
          required: false,
          order: 7
        }),
        new TextboxQuestion({
          key: 'deletedAt',
          label: 'Deleted at',
          readOnly: true,
          required: false,
          order: 8
        })
      ];
      return questions.sort((a, b) => a.order - b.order);
    }

    if (name === 'user-right-group') {
      const userRights: UserRight[] = ServiceTools.getEntitiesFromFirstContext(
        await this.userRightService.getEntities(),
        this.messageService,
        'user rights'
      );
      const userRightValues: { key: any, value: string }[] = [];
      for (const userRight of userRights) {
        userRightValues.push({key: userRight.id, value: `${userRight.name} (${userRight.target} ${userRight.id})`});
      }

      const groups: UserRight[] = ServiceTools.getEntitiesFromFirstContext(
        await this.groupService.getEntities(),
        this.messageService,
        'user right groups'
      );
      // const groups: Group[] = await this.groupService.getEntities();
      const groupValues: { key: any, value: string }[] = [];
      for (const group of groups) {
        groupValues.push({key: group.id, value: `${group.name} (${group.id})`});
      }

      const types: { key: any, value: string }[] = [
        {key: 'rf', value: 'Read, frontend (rf)'},
        {key: 'wf', value: 'Write, frontend (wf)'},
        {key: 'rb', value: 'Read, backend (rb)'},
        {key: 'wb', value: 'Write, backend (wb)'},
      ];

      const questions: QuestionBase<any>[] = [
        new TextboxQuestion({
          key: 'id',
          label: 'Id',
          required: true,
          order: 1
        }),
        new DropdownQuestion({
          key: 'groupId',
          label: 'Group id',
          required: true,
          order: 2,
          options: groupValues
        }),
        new DropdownQuestion({
          key: 'userRightId',
          label: 'User right id',
          required: true,
          order: 3,
          options: userRightValues
        }),
        new DropdownQuestion({
          key: 'type',
          label: 'Type',
          required: true,
          order: 4,
          options: types
        }),
        new TextboxQuestion({
          key: 'createdAt',
          readOnly: true,
          required: false,
          label: 'Created at',
          order: 5
        }),
        new TextboxQuestion({
          key: 'updatedAt',
          readOnly: true,
          required: false,
          label: 'Updated at',
          order: 6
        }),
        new TextboxQuestion({
          key: 'deletedAt',
          readOnly: true,
          required: false,
          label: 'Deleted at',
          order: 7
        })
      ];
      return questions.sort((a, b) => a.order - b.order);
    }

    if (name === 'user-right') {
      const questions: QuestionBase<any>[] = [
        new TextboxQuestion({
          key: 'id',
          label: 'Id',
          required: true,
          order: 1
        }),
        new TextboxQuestion({
          key: 'name',
          label: 'Name',
          required: true,
          order: 2
        })
        ,
        new TextboxQuestion({
          key: 'target',
          label: 'Target',
          required: true,
          order: 3
        })
        ,
        new TextboxQuestion({
          key: 'createdAt',
          readOnly: true,
          required: false,
          label: 'Created at',
          order: 4
        })
        ,
        new TextboxQuestion({
          key: 'updatedAt',
          readOnly: true,
          required: false,
          label: 'Updated at',
          order: 5
        })
        ,
        new TextboxQuestion({
          key: 'deletedAt',
          readOnly: true,
          required: false,
          label: 'Deleted at',
          order: 6
        })
      ];
      return questions.sort((a, b) => a.order - b.order);
    }

    if (name === 'additional-right') {
      const questions: QuestionBase<any>[] = [
        new TextboxQuestion({
          key: 'id',
          label: 'Id',
          required: true,
          order: 1
        }),
        new TextboxQuestion({
          key: 'name',
          label: 'Name',
          required: true,
          order: 2
        })
        ,
        new TextboxQuestion({
          key: 'target',
          label: 'Target',
          required: true,
          order: 3
        })
        ,
        new TextboxQuestion({
          key: 'createdAt',
          readOnly: true,
          required: false,
          label: 'Created at',
          order: 4
        })
        ,
        new TextboxQuestion({
          key: 'updatedAt',
          readOnly: true,
          required: false,
          label: 'Updated at',
          order: 5
        })
        ,
        new TextboxQuestion({
          key: 'deletedAt',
          readOnly: true,
          required: false,
          label: 'Deleted at',
          order: 6
        })
      ];
      return questions.sort((a, b) => a.order - b.order);
    }

    if (name === 'automation-mapping') {
      const questions: QuestionBase<any>[] = [
        new TextboxQuestion({
          key: 'id',
          label: 'Id',
          required: true,
          order: 1
        }),
        new TextboxQuestion({
          key: 'regoId',
          label: 'Rego id',
          required: true,
          order: 2
        })
        ,
        new TextboxQuestion({
          key: 'automationId',
          label: 'Automation id',
          required: true,
          order: 3
        })
        ,
        new TextboxQuestion({
          key: 'createdAt',
          readOnly: true,
          required: false,
          label: 'Created at',
          order: 4
        })
        ,
        new TextboxQuestion({
          key: 'updatedAt',
          readOnly: true,
          required: false,
          label: 'Updated at',
          order: 5
        })
        ,
        new TextboxQuestion({
          key: 'deletedAt',
          readOnly: true,
          required: false,
          label: 'Deleted at',
          order: 6
        })
      ];
      return questions.sort((a, b) => a.order - b.order);
    }

    if (name === 'rego-vivo-mapping') {
      const questions: QuestionBase<any>[] = [
        new TextboxQuestion({
          key: 'id',
          label: 'Id',
          required: true,
          order: 1
        }),
        new TextboxQuestion({
          key: 'regoId',
          label: 'Rego id',
          required: true,
          order: 2
        })
        ,
        new TextboxQuestion({
          key: 'vivoId',
          label: 'Vivo id',
          required: true,
          order: 3
        })
        ,
        new TextboxQuestion({
          key: 'createdAt',
          readOnly: true,
          required: false,
          label: 'Created at',
          order: 4
        })
        ,
        new TextboxQuestion({
          key: 'updatedAt',
          readOnly: true,
          required: false,
          label: 'Updated at',
          order: 5
        })
        ,
        new TextboxQuestion({
          key: 'deletedAt',
          readOnly: true,
          required: false,
          label: 'Deleted at',
          order: 6
        })
      ];
      return questions.sort((a, b) => a.order - b.order);
    }

    if (name === 'user') {
      const questions: QuestionBase<any>[] = [
        new TextboxQuestion({
          key: 'email',
          label: 'Email',
          required: true,
          order: 1
        }),
        new TextboxQuestion({
          key: 'name',
          label: 'Name',
          required: false,
          order: 3
        }),
        new TextboxQuestion({
          key: 'tenant_id',
          label: 'Tenant id',
          required: false,
          readOnly: true,
          order: 4
        }),
        new TextboxQuestion({
          key: 'user_id',
          label: 'User id',
          required: false,
          readOnly: true,
          order: 4
        }),

        new TextboxQuestion({
          key: 'last_login',
          label: 'Last login',
          required: false,
          readOnly: true,
          order: 5
        }),
        new TextboxQuestion({
          key: 'logins_count',
          label: 'Logins count',
          required: false,
          readOnly: true,
          order: 6
        }),
        new TextboxQuestion({
          key: 'email_verified',
          label: 'Email verified',
          required: false,
          readOnly: true,
          order: 7
        }),
        new DateQuestion({
          key: 'created_at',
          readOnly: true,
          required: false,
          label: 'Created at',
          order: 8
        }),
        // new TextboxQuestion({
        //   key: 'app_metadata.tenant_id',
        //   readOnly: true,
        //   required: false,
        //   label: 'Tenant id',
        //   order: 9
        // })

        //
        // created_at?: string;
        // updated_at?: string;
        // identities?: Identity[];
        // app_metadata?: AppMetadata;
        // user_metadata?: UserMetadata;
        // picture?: string;
        // nickname?: string;
        // last_ip?: string;
        // blocked?: boolean;
        // given_name?: string;
        // family_name?: string;


      ];
      return questions.sort((a, b) => a.order - b.order);
    }
    return null;
  }
}
